<template>
  <div>
    <el-dialog title="新增权限" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="30%" :before-close="resetForm" :close-on-click-modal='false'>
      <el-form label-width="90px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="权限名称" prop="accessName">
          <el-input v-model.trim="form.accessName" autocomplete="off" placeholder="请输入权限名"></el-input>
        </el-form-item>
        <el-form-item label="权限标志" prop="accessValue">
          <el-input v-model.trim="form.accessValue" autocomplete="off" placeholder="权限标志"></el-input>
        </el-form-item>
        <el-form-item label="权限路径" prop="accessUrl">
          <el-input v-model.trim="form.accessUrl" autocomplete="off" placeholder="请输入权限路径"></el-input>
        </el-form-item>
        <el-form-item label="请求方式" prop="requestMethod">
          <el-select v-model="form.requestMethod" style="width:100%" :clearable="clearable">
            <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" autocomplete="off" :rows="5" maxlength="100" show-word-limit placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addAccess } from '@/api/permissionManager'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        accessUrl: ''
      },
      rules: {
        accessName: [
          { required: true, message: '请输入权限名', trigger: 'blur' }
        ],
        /* accessUrl: [
          { required: true, message: '请输入权限路径', trigger: 'change' }
        ], */
        accessValue: [
          { required: true, message: '请输入权限标志', trigger: 'change' }
        ]
      },
      options: [
        {
          id: 0,
          name: 'GET'
        },
        {
          id: 1,
          name: 'HEAD'
        },
        {
          id: 2,
          name: 'POST'
        },
        {
          id: 3,
          name: 'PUT'
        },
        {
          id: 4,
          name: 'PATCH'
        },
        {
          id: 5,
          name: 'DELETE'
        },
        {
          id: 6,
          name: 'OPTIONS'
        },
        {
          id: 7,
          name: 'TRACE'
        }
      ],
      clearable: true
    }
  },
  watch: {
    'form.accessUrl': {
      handler (val) {
        console.log(val)
        if (val !== '') {
          // this.form.requestMethod = ''
          this.clearable = false
        } else {
          this.clearable = true
        }
      },
      immediate: true
    }
  },
  created () {
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.form)
        if (valid) {
          const params = Object.assign({}, this.form)
          addAccess(params).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('closeAddDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
